import HOCWatchValue from 'components/common/hoc-watch-value';
import Separator from 'components/common/separator';
import Text from 'components/elements/text';
import * as React from 'react';

import CruiseSaleGuestDetailTable from './item-table';

export default function CruiseSaleItemDetailTable(props: {
  parentIndex: number;
}) {
  const _values = HOCWatchValue({
    keys: [`approvalable.cruiseSales.${props.parentIndex}`],
  });
  const { isGroupedPrice, cruiseSaleGuests } =
    _values[`approvalable.cruiseSales.${props.parentIndex}`];

  if (!cruiseSaleGuests.length) {
    return <></>;
  }

  if (isGroupedPrice) {
    return (
      <CruiseSaleGuestDetailTable
        guestIndex={0}
        parentIndex={props.parentIndex}
      />
    );
  }

  return (
    <>
      {cruiseSaleGuests.map((field, idx) => (
        <React.Fragment key={field.id}>
          <Separator gap={24} />
          <Text variant="ParagraphSmall">{field.guestName || '-'}</Text>
          <Separator gap={16} />
          <CruiseSaleGuestDetailTable
            guestIndex={idx}
            parentIndex={props.parentIndex}
          />
        </React.Fragment>
      ))}
    </>
  );
}
